import type { SVGProps } from 'react'
const LineArrowLeft = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M21 11.25H5.31l5.22-5.22-1.06-1.06-6.145 6.145a1.26 1.26 0 0 0 0 1.77L9.47 19.03l1.06-1.06-5.22-5.22H21z"
		/>
	</svg>
)
export { LineArrowLeft }
